export enum TabSize {
  SMALL = "SMALL",
  LARGE = "LARGE"
}
